import { downloadFile, IFileReturn } from "../downloadFile";

/**
 * Download the ARS JSON representation of a report.
 *
 * @param backEndUrl - Base backend URL
 * @param hierarchyId - Report hierarchy id
 * @param reportName - Report name used in filename
 * @returns Axios-like result object
 */
export const downloadArsReport = async (
  backEndUrl: string,
  hierarchyId: string,
  reportName: string,
): Promise<IFileReturn> => {
  const fileName = `${reportName}_ars.json`;
  const response = await downloadFile({
    url: `${backEndUrl}Ars/Hierarchy/${hierarchyId}`,
    fileName,
    fileType: "application/json",
    blob: false,
    successMessage: "ARS JSON file successfully downloaded",
    errorMessage: "An error has occurred downloading the ARS JSON file",
    controller: new AbortController(),
  });
  return response;
};
